import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import {
    DataService,
    DeletionResult,
    GetCategoryList,
    GetCustomerGroups,
    GetCustomerGroupWithCustomers,
    GetZones,
    LanguageCode,
    ModalService,
    NotificationService,
    QueryResult,
    ServerConfigService,
} from '@ishop/admin-ui/core';
import { BehaviorSubject, combineLatest, EMPTY, Observable, of } from 'rxjs';
import { distinctUntilChanged, map, mapTo, shareReplay, switchMap, tap } from 'rxjs/operators';
 
@Component({
    selector: 'vdr-vendor-category-list',
    templateUrl: './vendor-category-list.component.html',
    styleUrls: ['./vendor-category-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VendorCategoryListComponent implements OnInit {
   
    activeCollectionId$: Observable<string | null>;
    activeCollectionTitle$: Observable<string>;
    items$: Observable<GetCategoryList.Items[]>;
    availableLanguages$: Observable<LanguageCode[]>;
    contentLanguage$: Observable<LanguageCode>;
    private queryResult: QueryResult<any>;

    constructor(
        private dataService: DataService,
        private notificationService: NotificationService,
        private modalService: ModalService,
        public route: ActivatedRoute,
        private router: Router,
        private serverConfigService: ServerConfigService,
    ) {}

    ngOnInit(): void {
   
        this.queryResult = this.dataService.settings.getCategories(1000, 0);
        this.items$ = this.queryResult.mapStream(data => data.vendorCategories.items).pipe(shareReplay(1));
      /*  this.activeCollectionId$ = this.route.paramMap.pipe(
                map(pm => pm.get('contents')),
                distinctUntilChanged(),
            );
    
        this.activeCollectionTitle$ = combineLatest(this.activeCollectionId$, this.items$).pipe(
                map(([id, collections]) => {
                    if (id) {
                        const match = collections.find(c => c.id === id);
                        return match ? match.name : '';
                    }
                    return '';
                }),
            );
            this.availableLanguages$ = this.serverConfigService.getAvailableLanguages();
            this.contentLanguage$ = this.dataService.client
                .uiState()
                .mapStream(({ uiState }) => uiState.contentLanguage)
                .pipe(tap(() => this.refresh()));

       */
        
    }
    ngOnDestroy() {
        this.queryResult.completed$.next();
    }
    private refresh() {
        this.queryResult.ref.refetch();
    }
    setLanguage(code: LanguageCode) {
        this.dataService.client.setContentLanguage(code).subscribe();
    }
    deleteCategory(id: string) {
        this.items$
            .pipe(  switchMap( () => {
                    return this.modalService.dialog({
                        title: _('catalog.confirm-delete-collection'),
                        body:   undefined,
                        buttons: [
                            { type: 'secondary', label: _('common.cancel') },
                            { type: 'danger', label: _('common.delete'), returnValue: true },
                        ],
                    });
                }),
                switchMap(response => (response ? this.dataService.settings.deleteCategory(id) : EMPTY)),
            )
            .subscribe(
                () => {
                    this.notificationService.success(_('common.notify-delete-success'), {
                        entity: 'Category',
                    });
                    this.refresh();
                },
                err => {
                    this.notificationService.error(_('common.notify-delete-error'), {
                        entity: 'Category',
                    });
                },
            );
    }

   /* create() {
        this.modalService
            .fromComponent(CustomerGroupDetailDialogComponent, { locals: { group: { name: '' } } })
            .pipe(
                switchMap((name) =>
                    name ? this.dataService.customer.createCustomerGroup({ name, customerIds: [] }) : EMPTY,
                ),
                // refresh list
                switchMap(() => this.dataService.customer.getCustomerGroupList().single$),
            )
            .subscribe(
                () => {
                    this.notificationService.success(_('common.notify-create-success'), {
                        entity: 'CustomerGroup',
                    });
                },
                (err) => {
                    this.notificationService.error(_('common.notify-create-error'), {
                        entity: 'CustomerGroup',
                    });
                },
            );
    }

    delete(groupId: string) {
        this.modalService
            .dialog({
                title: _('customer.confirm-delete-customer-group'),
                buttons: [
                    { type: 'secondary', label: _('common.cancel') },
                    { type: 'danger', label: _('common.delete'), returnValue: true },
                ],
            })
            .pipe(
                switchMap((response) =>
                    response ? this.dataService.customer.deleteCustomerGroup(groupId) : EMPTY,
                ),

                switchMap((result) => {
                    if (result.deleteCustomerGroup.result === DeletionResult.DELETED) {
                        // refresh list
                        return this.dataService.customer
                            .getCustomerGroupList()
                            .mapSingle(() => ({ errorMessage: false }));
                    } else {
                        return of({ errorMessage: result.deleteCustomerGroup.message });
                    }
                }),
            )
            .subscribe(
                (result) => {
                    if (typeof result.errorMessage === 'string') {
                        this.notificationService.error(result.errorMessage);
                    } else {
                        this.notificationService.success(_('common.notify-delete-success'), {
                            entity: 'CustomerGroup',
                        });
                    }
                },
                (err) => {
                    this.notificationService.error(_('common.notify-delete-error'), {
                        entity: 'CustomerGroup',
                    });
                },
            );
    }

    update(group: GetCustomerGroups.Items) {
        this.modalService
            .fromComponent(CustomerGroupDetailDialogComponent, { locals: { group } })
            .pipe(
                switchMap((name) =>
                    name ? this.dataService.customer.updateCustomerGroup({ id: group.id, name }) : EMPTY,
                ),
            )
            .subscribe(
                () => {
                    this.notificationService.success(_('common.notify-update-success'), {
                        entity: 'CustomerGroup',
                    });
                },
                (err) => {
                    this.notificationService.error(_('common.notify-update-error'), {
                        entity: 'CustomerGroup',
                    });
                },
            );
    }

    closeMembers() {
        const params = { ...this.route.snapshot.params };
        delete params.contents;
        this.router.navigate(['./', params], { relativeTo: this.route, queryParamsHandling: 'preserve' });
    }

    addToGroup(group: GetCustomerGroupWithCustomers.CustomerGroup) {
        this.modalService
            .fromComponent(AddCustomerToGroupDialogComponent, {
                locals: {
                    group,
                    route: this.route,
                },
                size: 'md',
                verticalAlign: 'top',
            })
            .pipe(
                switchMap((customerIds) =>
                    customerIds
                        ? this.dataService.customer
                              .addCustomersToGroup(group.id, customerIds)
                              .pipe(mapTo(customerIds))
                        : EMPTY,
                ),
            )
            .subscribe({
                next: (result) => {
                    this.notificationService.success(_(`customer.add-customers-to-group-success`), {
                        customerCount: result.length,
                        groupName: group.name,
                    });
                    this.refreshActiveGroupMembers$.next();
                    this.selectedCustomerIds = [];
                },
            });
    }

    removeFromGroup(group: GetZones.Zones, customerIds: string[]) {
        this.dataService.customer.removeCustomersFromGroup(group.id, customerIds).subscribe({
            complete: () => {
                this.notificationService.success(_(`customer.remove-customers-from-group-success`), {
                    customerCount: customerIds.length,
                    groupName: group.name,
                });
                this.refreshActiveGroupMembers$.next();
                this.selectedCustomerIds = [];
            },
        });
    }*/
}
